import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-warning-popup',
  templateUrl: 'warning-popup.component.html',
  styleUrls: ['./warning-popup.component.less', '../shared/common.less'],
})
export class WarningPopupComponent implements OnInit {
  @Output() payment = new EventEmitter<boolean>();
  @Input() paymentLine: boolean;
  @Input() modifiedLine: boolean;
  @Input() validateButton: boolean;
  @Input() cancelButton: boolean;
  @Input() callButton: boolean;
  @Input() modifyButton: boolean;
  @Input() confirmButton: boolean;
  @Input() understoodButton: boolean;
  @Input() votingAvailableButtons: boolean;
  @Input() phoneInput: boolean;
  @Input() firstText: string;
  @Input() title: string;
  @Input() secondText: string;
  @Input() thirdText: string;
  @Input() index: number;
  @Input() isAssoc: boolean;
  @Input() origin: string;
  @Input() isValidated: boolean;

  @Output() contactPhone = new EventEmitter<string>();
  @Output() endDetailsPopup = new EventEmitter<boolean>();


  isPhoneValid = false;
  status: number;

  launch() {
    this.payment.emit(true);
  }

  clicAction($event) {
    if (
      $event.target.className === 'div-arriere-plan-action' ||
      $event.target.className === 'div-global-action'
    ) {
      this.cancelDetails(false);
    }
  }

  onPhoneEdit($event) {
    this.isPhoneValid = this.isValid($event.target.value);
  }

  isValid(p: string) {
    const phoneRe = /^\+?[\d]{0,15}$/;
    return phoneRe.test(p);
  }

  sendContactPhone() {
    const element = document.getElementById('phone-input') as HTMLInputElement;
    this.contactPhone.emit(element.value);
  }

  cancelDetails(value) {
    this.endDetailsPopup.emit(value);
  }

  cancel() {
    this.payment.emit(false);
  }

  ngOnInit() {
    if (this.origin === 'addVoters' || this.origin === 'addSMS') {
      this.status = 1;
    }
  }
}
